module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAGCAYAAADzG6+8AAAAAXNSR0IArs4c6QAAANtJREFUKFNNj7FKxEAURe8lCewnWAqmVNDKUjvXTnHBagID+ZD5k4SZSnTZ7UzpH6homcLST9iQwNWEDOQ1j8e5B+4j5qnr+iRJkg3J377vn6y1h8icc2me5w+SjgE0xphPjtB7f0WyAbCaw/t/eB/FEMIrgPV8HyRdT2IIYQfgLgbH3XXdWVmW31VVnadp+r5kAF6i+Axgs4TDMFxYaz+896ckv5ZM0j5WvQTwRnKqKqkpiuI2hr33O5JTI0nj7+tJHGeudEPyp23brXNuWLBVlmWPko4AbI0x7R/7qFdy9JiT0gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grade/icon-dot.png
// module id = VBHj
// module chunks = 1